import { render, staticRenderFns } from "./ProjectsDigestsItemQuotes.vue?vue&type=template&id=09ab3f0a&scoped=true"
import script from "./ProjectsDigestsItemQuotes.vue?vue&type=script&lang=js"
export * from "./ProjectsDigestsItemQuotes.vue?vue&type=script&lang=js"
import style0 from "./ProjectsDigestsItemQuotes.vue?vue&type=style&index=0&id=09ab3f0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ab3f0a",
  null
  
)

export default component.exports